//# sourceMappingURL=my-date-range.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-date-range.interface.js
// module id = 989
// module chunks = 3